<i class="fa fa-cog fa-spin fa-4x"></i>